import { Phone } from "lucide-react";
import { ContactMenu } from "./ContactMenu";
import { BRAND, SERVICE_AREA, TEL_HREF } from "../../lib/contact";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-navy text-ivory py-12 pb-32 md:pb-12">
    <div className="max-w-6xl mx-auto px-6 flex flex-wrap justify-between gap-6 text-lg">
      <span className="disp uppercase">{BRAND}</span>
      <span data-testid="footer-service-area">{SERVICE_AREA}</span>
      <a href="#contact" data-testid="footer-inquiry-link" className="underline">Kérjen Tájékoztatást</a>
    </div>
  </footer>
);

export const MobileBar = () => (
  <div data-testid="mobile-contact-bar" className="md:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-2 bg-ivory border-t-2 border-navy">
    <a href={TEL_HREF} data-testid="mobile-call-button" className="bg-coral text-coral-ink py-4 text-center text-lg font-semibold inline-flex justify-center items-center gap-2">
      <Phone className="h-5 w-5" /> Hívás most
    </a>
    <ContactMenu
      side="top"
      testid="mobile-messaging"
      triggerClassName="bg-navy text-ivory py-4 text-center text-lg font-semibold"
    />
  </div>
);
